<template>
  <v-container fluid>
    <template v-if="!busy && user">
      <div class="d-flex align-center pb-3">
        <div class="display-1">
          {{ user.name }}
        </div>
        <v-spacer></v-spacer>
        <v-btn icon
               color="primary"
               rounded
               @click.prevent="fetchData(userID)">
          <v-icon>
            fal fa-redo
          </v-icon>
        </v-btn>
      </div>

      <router-view :user="user"
                   @updated="fetchData(userID)">
      </router-view>
    </template>

  </v-container>
</template>
<script>
import userService from "../../../../ml/services/userService";
import metaService from "../../services/metaService";

export default {
  /*metaInfo() {
    this.$store.commit('setTitle', this.user ? this.user.name : 'User');
    return {
      title: this.$store.getters.title,
    }
  },*/
  beforeRouteUpdate(to, from, next) {
    console.log('User.vue - beforeRouteUpdate(to, from, next)');
    if (to.params.userID) {
      this.fetchData(to.params.userID);
    }
    next();
  },
  data() {
    return {
      busy: false,
      user: null,
    }
  },
  computed: {
    userID() {
      return parseInt(this.$route.params.userID);
    },
  },
  created() {
    this.fetchData(this.userID);
  },
  methods: {
    async fetchData(userID) {
      this.user = await userService.getUser(userID);
    }
  }
}
</script>
